import area from "./Area";
import bar from "./Bar";
import xbar from "./BarX";
import donut from "./Donut";
import line from "./Line";
import pie from "./Pie";
import pie3D from "./Pie3D";
import radar from "./Radar";
import scatter from "./Scatter";
import spline from "./Spline";
import splineArea from "./SplineArea";
import treeMap from "./TreeMap";

const seriesTypes = {
	line,
	spline,
	area,
	splineArea,
	scatter,
	pie,
	pie3D,
	donut,
	radar,
	bar,
	xbar,
	treeMap,
};

export default seriesTypes;
